module.exports = __webpack_public_path__ + "img/college_icon3.a3af2bd.png";